<script setup>
import { onMounted } from 'vue'
import stripslashes, { nl2br } from '@/Shared/helper.js'
import Overlay from '@/Shared/Overlay'
import ButtonClose from '@/Shared/Buttons/ButtonClose'
import Icon from '@/Shared/Icons/Icon'

const props = defineProps({
  overlay: String,
  category: String,
  func: Function,
  params: Object,
  pref: Object,
})

const emit = defineEmits(['close'])

// filter products by category
const filterBrandByBrandSlug = function (slug) {
  const r = props.pref.brands.filter((i) => i.brandSlug === slug)
  const t = (r[0]) ? stripslashes(r[0].brandName) : ''
  return t
}

const getBrandName = (slug) => {
  let out = []
  const exploded = slug.split(',')
  // console.log( 'exploded' )
  // console.log( exploded )
  exploded.forEach((each) => {
    // console.log( filterBrandByBrandSlug(each) )
    out.push(filterBrandByBrandSlug(each))
  })

  // const l = props.pref.brands.filter((i) => i.brandSlug == slug)
  // let r = l[0] ? stripslashes(l[0].brandName) : 'なし'
  // return r
  return out.toString()
}
const getProductName = (item) => {
  const r = item ? item : 'なし'
  return r
}
const getPurchaseDate = (relatedDate) => {
  const r = relatedDate ? relatedDate: 'なし'
  return r
}
const getShopName = (shopName) => {
  const r = shopName ? shopName : 'なし'
  return r
}

const getColor = (color) => {
  const r = color ? color : 'なし'
  return r
}
const getSize = (size) => {
  const r = size ? size : 'なし'
  return r
}

const clickAction = () => {
  emit('close')
  props.func()
}

onMounted(() => {
  // console.log(getBrandName('chaco'))
  // console.log(props.params.contactName)
  // console.log(props.params.contactFurigana)
  // console.log(props.params)
  // console.log(props.pref)
})
</script>

<template>
  <div class="contact-modal modal-container center-container xl:w-main-xl 2xl:w-main-2xl xl:!left-auto">
    <Overlay v-if="props.overlay !== 'false'" @click="emit('close')" />
    <div class="bg-white rounded-[20px] xs:w-[80vw] relative z-20 max-w-[600px] md:min-w-[600px] overflow-hidden">
      <ButtonClose class="absolute z-20 top-0 right-0 p-[22px] origin-top-right scale-[1] sm:scale-[1.2]" @click="emit('close')" />

      <div class="max-h-[80dvh] overflow-y-auto">
        <div class="p-[30px] sm:p-[40px] md:p-[50px]">
          <template v-if="category === 'form'">
            <h2 class="text-[18px] xs:text-[20px] sm:text-[22px] mb-[10px] sm:mb-[20px] font-bold leading-[1.6]">お問い合わせ内容の確認</h2>
            <p class="mb-[20px] sm:mb-[30px] leading-[1.6]">以下の内容を確認した上で、送信してください。</p>
            <div class="">
              <table class="w-full border-t border-t-[#ddd] [&_tr]:border-b [&_tr]:border-b-[#ddd] [&_th]:font-semibold [&_th]:text-left [&_th]:w-[80px] xs:[&_th]:w-[90px] sm:[&_th]:whitespace-nowrap [&_th]:align-top [&_td]:align-top [&_th]:py-[20px] [&_th]:pr-[10px] sm:[&_th]:pr-[20px] [&_td]:py-[20px] [&_td]:break-all mb-[30px] sm:mb-[40px] leading-[1.4]">
                <tr>
                  <th>お名前</th>
                  <td>
                    {{ params.contactName }}
                  </td>
                </tr>
                <tr v-if="params.contactFurigana">
                  <th>フリガナ</th>
                  <td>
                    {{ params.contactFurigana }}
                  </td>
                </tr>
                <tr v-if="params.contactBusinessName">
                  <th>御社名・店舗名</th>
                  <td>
                    {{ params.contactBusinessName }}
                  </td>
                </tr>
                <tr v-if="params.contactBusinessUrl">
                  <th>会社概要等のホームページURL</th>
                  <td>
                    {{ params.contactBusinessUrl }}
                  </td>
                </tr>
                <tr>
                  <th>Eメール</th>
                  <td>{{ params.contactEmail1 }}</td>
                </tr>
                <tr>
                  <th>件名</th>
                  <td><span v-html="params.subject" /></td>
                </tr>
                <tr v-if="params.relatedBrand && params.relatedBrand != ''">
                  <th>興味のあるブランド</th>
                  <td><span v-html="getBrandName(params.relatedBrand)" /></td>
                </tr>
                <tr v-if="params.relatedProduct && params.relatedProduct != ''">
                  <th>商品名</th>
                  <td><span v-html="getProductName(params.relatedProduct)" /></td>
                </tr>
                <tr v-if="params.relatedDate && params.relatedDate != ''">
                  <th>ご購入日</th>
                  <td><span v-html="getPurchaseDate(params.relatedDateJP)" /></td>
                </tr>
                <tr v-if="params.relatedShop && params.relatedShop != ''">
                  <th>ご購入店</th>
                  <td><span v-html="getShopName(params.relatedShop)" /></td>
                </tr>
                <tr v-if="params.relatedColor && params.relatedColor != ''">
                  <th>カラー</th>
                  <td><span v-html="getColor(params.relatedColor)" /></td>
                </tr>
                <tr v-if="params.relatedSize && params.relatedSize != ''">
                  <th>サイズ</th>
                  <td><span v-html="getSize(params.relatedSize)" /></td>
                </tr>

                <tr v-if="params.volume && params.volume != ''">
                  <th>年間希望<br class="sm:hidden" />取引額</th>
                  <td><span v-html="params.volume" /></td>
                </tr>
                <tr>
                  <th>メッセージ</th>
                  <td><span v-html="nl2br(params.contactMessage)" /></td>
                </tr>
              </table>
            </div>
            <button class="submitBtn" type="button" @click.prevent="clickAction()">送信する<Icon type="arrow" /></button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
